import { format } from "date-fns";
import { Message } from "../utils/Types";
import ListItemPlaceholder from "./ListItemPlaceholder.tsx";
import FileDownloadButton from "./FileDownloadButton";
import { useApiConfig } from "../utils/ApiConfigContext.tsx";
import { ContactLabel } from "./ContactLabel.tsx";

interface MessageListProps {
  messages: Message[] | undefined;
  loading: boolean | false;
  error: string | undefined;
}

const MessageList: React.FC<MessageListProps> = (props: MessageListProps) => {
  const { apiUrls } = useApiConfig();
  let body = null;

  if (props.loading) {
    //show skeletons to let the user know something is happening
    body = (
      <>
        <ListItemPlaceholder />
        <ListItemPlaceholder />
      </>
    );
  } else if (props.error) return <p>{props.error}</p>;
  else {
    body = (
      <>
        {props.messages?.map((message, i) => (
          <div className="py-4" key={i}>
            {message.content && message.type == "sms" && <p>{message.content}</p>}
            {message.content &&
              message.type == "mms" &&
              (message.content as any[]).map((media, j) => (
                <FileDownloadButton
                  url={apiUrls.getMessageMediaById(message.id, media.id)}
                  filename={media.title}
                  key={j}
                />
              ))}
            <div className="text-right">
              <p className="text-sm text-muted-foreground">
                {message.error && <span className="text-red-500 font-semibold">Error Sending</span>}
                {message.sending && !message.error && "Sending..."}
                {!message.sending && format(message.created.toLocaleString(), "MM-dd-yyyy h:mm aaa")}
              </p>
              <small className="text-sm leading-none font-semibold">
                <ContactLabel identity={message.from} displayName={message.from} />
              </small>
            </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <div className="relative">
      <div className="divide-y">{body}</div>
    </div>
  );
};

export default MessageList;
